<div class="fm-datepicker-wrapper">
  <div
    class="fm-datepicker-trigger form-control fm-form-control"
    [class.is-invalid]="invalid()"
    (click)="open($event)"
  >
    <img
      class="fm-svg"
      src="images/icons/fm-calendar.svg"
      alt="Date Icon"
      style="width: 16px; height: 16px; flex-shrink: 0"
    />
    <span [class.fm-dp-placeholder]="!display()">
      {{ display() || placeholder() }}
    </span>
  </div>
  @if (isOpen()) {
    <div class="fm-dp-backdrop" (click)="close()"></div>
    <div class="fm-dp-dropdown" [class.fm-dp-dropup]="dropUp()">
      <div class="fm-dp-header">
        <button type="button" class="fm-dp-nav" (click)="prevMonth()">&#8249;</button>
        <span class="fm-dp-month-label">{{ monthLabel() }}</span>
        <button type="button" class="fm-dp-nav" (click)="nextMonth()">&#8250;</button>
      </div>
      <div class="fm-dp-weekdays">
        <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span
        ><span>Sa</span>
      </div>
      <div class="fm-dp-grid">
        @for (cell of calendarDays(); track $index) {
          <button
            type="button"
            class="fm-dp-day"
            [class.fm-dp-today]="cell.isToday"
            [class.fm-dp-selected]="cell.isSelected"
            [class.fm-dp-empty]="!cell.isCurrentMonth"
            [class.fm-dp-disabled]="cell.isDisabled"
            [disabled]="cell.isDisabled || !cell.isCurrentMonth"
            (click)="select(cell.date)"
          >
            {{ cell.day !== null ? cell.day : '' }}
          </button>
        }
      </div>
    </div>
  }
</div>
